module.exports = __webpack_public_path__ + "img/store.15d48a7a.png";